(() => {
  if (window.ryppleAccordionEnhance) {
    window.ryppleAccordionEnhance(document);
    return;
  }

  const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
  const activeAnimations = new WeakMap();

  const enhance = (root) => {
    root.querySelectorAll('.rp-mini-accordions details, .rp-mechanism-benefit, .rp-details details').forEach((details) => {
      if (details.dataset.rpAccordionReady === 'true') return;
      const summary = details.querySelector(':scope > summary');
      const panel = details.querySelector(':scope > div');
      if (!summary || !panel) return;
      const quickAnswer = details.matches('.rp-mini-accordions details');
      details.dataset.rpAccordionReady = 'true';

      summary.addEventListener('click', (event) => {
        event.preventDefault();
        const previousIntent = details.dataset.rpTargetOpen === undefined
          ? details.open
          : details.dataset.rpTargetOpen === 'true';
        const opening = !previousIntent;
        details.dataset.rpTargetOpen = String(opening);

        const running = activeAnimations.get(details);
        const currentHeight = details.open ? panel.getBoundingClientRect().height : 0;
        const currentOpacity = quickAnswer && details.open ? Number(getComputedStyle(panel).opacity) : 0;
        if (running) {
          running.cancel();
          activeAnimations.delete(details);
        }

        if (reduceMotion.matches || typeof panel.animate !== 'function') {
          details.open = opening;
          panel.style.removeProperty('height');
          details.classList.remove('is-closing');
          delete details.dataset.rpTargetOpen;
          return;
        }

        if (!details.open) details.open = true;
        panel.style.height = `${currentHeight}px`;
        const fullHeight = panel.scrollHeight;
        const targetHeight = opening ? fullHeight : 0;
        details.classList.toggle('is-closing', !opening);

        if (Math.abs(currentHeight - targetHeight) < 1) {
          details.open = opening;
          panel.style.removeProperty('height');
          details.classList.remove('is-closing');
          delete details.dataset.rpTargetOpen;
          return;
        }

        const animation = panel.animate([
          { height: `${currentHeight}px`, ...(quickAnswer ? { opacity: currentOpacity } : {}) },
          { height: `${targetHeight}px`, ...(quickAnswer ? { opacity: opening ? 1 : 0 } : {}) }
        ], {
          duration: quickAnswer ? 280 : Math.min(420, Math.max(260, Math.abs(targetHeight - currentHeight) * 0.6)),
          easing: 'cubic-bezier(.22,.68,.22,1)',
          fill: 'forwards'
        });
        activeAnimations.set(details, animation);
        animation.onfinish = () => {
          if (activeAnimations.get(details) !== animation) return;
          activeAnimations.delete(details);
          details.open = opening;
          panel.style.removeProperty('height');
          details.classList.remove('is-closing');
          delete details.dataset.rpTargetOpen;
          animation.cancel();
        };
      });
    });
  };

  window.ryppleAccordionEnhance = enhance;
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => enhance(document), { once: true });
  } else {
    enhance(document);
  }
  document.addEventListener('shopify:section:load', (event) => enhance(event.target));
})();
